import { useMemo } from "react";
import { BoardColumnTable } from "../BoardColumnTable/BoardColumnTable";
import "./Board.css";
import { useBoardManager } from "../../../BoardsManagerProvider";

export const Board = () => {

    const { columns, activities, relations } = useBoardManager();

    const itemsByColumn = useMemo(() => {
        const statusIdsByColumn = new Map();

        relations
            .filter(r => r?.DataBeanProperties?.IsActive)
            .forEach(r => {
                const colId = r.DataBeanProperties.IDBoardColumn;
                const statusId = r.DataBeanProperties.IDWorkActivityStatuses;
                const arr = statusIdsByColumn.get(colId) ?? [];
                arr.push(statusId);
                statusIdsByColumn.set(colId, arr);
            });

        const activitiesByStatus = new Map();

        activities.forEach(a => {
            const statusId = a.DataBeanProperties.IDWorkActivityStatuses;
            if (!statusId) return;

            const arr = activitiesByStatus.get(statusId) ?? [];
            arr.push(a);
            activitiesByStatus.set(statusId, arr);
        });

        const result = new Map();

        columns.forEach(col => {
            const colId = col.DataBeanProperties.IDBoardColumns;
            const statusIds = statusIdsByColumn.get(colId) ?? [];

            const colItems = statusIds.flatMap(
                sid => activitiesByStatus.get(sid) ?? []
            );

            result.set(colId, colItems);
        });

        return result;
    }, [columns, activities, relations]);

    const sortedColumns = useMemo(() => {
        return [...columns].sort(
            (a, b) =>
                a.DataBeanProperties.Position - b.DataBeanProperties.Position
        );
    }, [columns]);

    return (
        <div className="board">
            {sortedColumns.map(col => {
                const colId = col.DataBeanProperties.IDBoardColumns;
                const items = itemsByColumn.get(colId) ?? [];

                return (
                    <BoardColumnTable key={colId} column={col} items={items} />
                );
            })}
        </div>
    );
};